import React, { useEffect, useState } from 'react';
import Logo from './Logo';
import Button from './Button';
import NavBurger from './NavBurger';

import styles from './Navigation.module.css';
import NavContainer from './NavContainer';
import { useLocation } from 'react-router-dom';

const Navigation = () => {
    const [navBurger, setNavBurger] = useState(false);
    const pathname = useLocation();
    const [role, setRole] = useState('public');

    useEffect(() => {
        setNavBurger(false);
    }, [pathname]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 700 && navBurger) {
                setNavBurger(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [navBurger, setNavBurger]);

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        setRole(storedUser?.role || 'public');
    }, []);

    return (
        <section className={styles.navigation}>
            <Logo />
            <NavContainer role={role} setRole={setRole} navBurger={navBurger} />
            <Button role={role} setRole={setRole} />
            <NavBurger navBurger={navBurger} setNavBurger={setNavBurger} />
        </section>
    );
};

export default Navigation;